import { endPoints } from "@/constants/apiSetting";
import httpClient from "@/common/service/HttpClient";
const BenefitsService = {
  getAllBenefits(obj) {
    return httpClient.post(endPoints.getAllBenefits, obj);
  },
  getAllBenefitsByPagination(obj) {
    return httpClient.post(endPoints.getAllBenefitsByPagination, obj);
  },
  getAllBenefitByStaffGrade(obj) {
    return httpClient.post(endPoints.getAllBenefitByStaffGrade, obj);
  },
  getBenefitDetail(obj) {
    return httpClient.post(endPoints.getBenefitDetail, obj);
  },
  addBenefit(obj) {
    return httpClient.post(endPoints.addBenefit, obj);
  },
  updateBenefit(obj) {
    return httpClient.post(endPoints.updateBenefit, obj);
  },
  deleteBenefit(obj) {
    return httpClient.post(endPoints.deleteBenefit, obj);
  },
};

export default BenefitsService;



// WEBPACK FOOTER //
// ./src/service/BenefitsService.js